<template>
    <phoenix-wrapper>
        
        <div class="content-page w-full" v-if="!loading">

            <div class="steps-container py-2">

                <div class="steps-title flex justify-around w-full mx-auto font-semibold" v-if="loan.signup_state_name != 'mail_campaign_user'">
                    <p class="text-black">Authorized lender</p>
                    <p class="text-black mr-5">Bank account</p>
                </div>

                <div class="step-progress flex justify-around my-5" v-if="loan.signup_state_name != 'mail_campaign_user'">
                    <PhoenixStepProgress :step="2" />
                </div>

                <ProgressBar
                    :steps="['Offer Code', 'Basic Info', 'Bank Info']"
                    :currentIndex="2"
                    v-if="loan.signup_state_name == 'mail_campaign_user'"
                />

            </div>
            
            <div class="white-bg-container bg-white rounded-lg px-10 py-5 sm:px-10 sm:py-10 md:px-20 md:py-20">
                <h2 class="my-5">Verify Bank Account</h2>

                <p style="max-width: 320px; color: #858585">
                    Once your account is verified and approved, you will get funded within 24 hours.
                </p>

                <DesiredLoan :amount="loan.amount | money(0)" />
                <br />
                <PhoenixBoxAction
                    @click="handlePlaid()"
                    text="Click here to securely verify your bank account."
                    label="Instant connection"
                    appareance="instant-connection"
                />
                <div class="divider-- flex justify-center items-center gap-5 mt-4 mb-0">
                    <div style="height: 1px; background-color: #d9dbde; width: 20px"></div>
                    <div class="text-black font-semibold">Or</div>
                    <div style="height: 1px; background-color: #d9dbde; width: 20px"></div>
                </div>

                <ManualBankingWarning class="mt-4" />

                <PhoenixBoxAction
                    @click="handleManual()"
                    text="Requires bank <br class='hidden md:block' /> statements."
                    label="Manual"
                    appareance="manual-connection"
                />
            </div>


        </div>

        <div class="if-loading" v-if="loading">
            <div class="inside-container-1 flex flex-col w-full sm:w-317 mx-auto">
                <h2 class="text-center text-2xl md:text-4xl">Verifying Bank Account</h2>
                <p class="text-center my-4">Please wait while we verify your bank account.</p>
            </div>

            <div v-if="proceeding" class="flex flex-grow justify-center items-center">
                <WaitingProgressBar :show-progress="proceeding" />
                <!-- <i class="fa fa-circle-notch fa-spin text-3xl" /> -->
            </div>
        </div>

        <AppBankManualModal 
            :showModal="showManual" 
            :gPageName="gTagPageName" 
            :gEventType="gEventType"
            :loan="loan" 
            @close="handleCloseManual" 
            @proceed="proceed" />
        
        <AppErrorPopup 
            :show="showErrorPopup" 
            :message="errorMessage" 
            @close="closeErrorPopup" 
        />
    </phoenix-wrapper>
</template>

<script>
import DesiredLoan from "./../../../../../components/DesiredLoan.vue";
import PhoenixBoxAction from "../../../components/PhoenixBoxAction.vue";
import AppBankManualModal from "../../../../../components/AppBankManualModal.vue";
import PhoenixStepProgress from "../../../components/PhoenixStepProgress.vue";
import WaitingProgressBar from "./../../../../../components/WaitingProgressBar.vue";
import ProgressBar from "../../../components/ProgressBar.vue";
import AppErrorPopup from "../../../../../components/AppErrorPopup.vue";
import ManualBankingWarning from "../../../../../components/ManualBankingWarning.vue";

export default {
    mixins: [
        require("../../../../../mixins/InteractsWithGtag").default,
        require("../../../../../mixins/VerifyMethods").default,
        require("../../../../../mixins/PageViewAnalytics").default,
    ],
    components: {
        DesiredLoan,
        PhoenixBoxAction,
        AppBankManualModal,
        PhoenixStepProgress,
        WaitingProgressBar,
        ProgressBar,
        AppErrorPopup,
        ManualBankingWarning
    },
    props: {
        user: {},
        loan: {},
        manual: {
            type: Boolean,
            default: false,
        },
        mxWidgetUrl: {},
        plaidLinkToken: {},
    },

    data() {
        return {
            gTagPageName: "VERIFY_ACCOUNT",
            gEventType: 'MarketPlaceSignUp',
            showBanking: false,
            showManual: false,
            mx: null,
            plaid: null,
            institution_id: null,
            institution_code: null,
            loading: false,
            proceeding: false,
            // for plaid asset / edge process
            attempts: 0,
            interval: null,
            maxAttempts: 12,
            // error popup state
            showErrorPopup: false,
            errorMessage: ''
        };
    },
    mounted() {
        window.dispatchEvent(new Event('resize'));
    },

    beforeDestroy() {
      if (this.interval) clearInterval(this.interval);
    },
};
</script>
